/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CompleteBindingRefreshRequestBody,
  CompleteBindingRefreshRequestBody$Outbound,
  CompleteBindingRefreshRequestBody$outboundSchema,
} from "../components/completebindingrefreshrequestbody.js";

export type CompleteBindingRefreshSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CompleteBindingRefreshRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  completeBindingRefreshRequestBody: CompleteBindingRefreshRequestBody;
};

/** @internal */
export type CompleteBindingRefreshSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CompleteBindingRefreshSecurity$outboundSchema: z.ZodMiniType<
  CompleteBindingRefreshSecurity$Outbound,
  CompleteBindingRefreshSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function completeBindingRefreshSecurityToJSON(
  completeBindingRefreshSecurity: CompleteBindingRefreshSecurity,
): string {
  return JSON.stringify(
    CompleteBindingRefreshSecurity$outboundSchema.parse(
      completeBindingRefreshSecurity,
    ),
  );
}

/** @internal */
export type CompleteBindingRefreshRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CompleteBindingRefreshRequestBody: CompleteBindingRefreshRequestBody$Outbound;
};

/** @internal */
export const CompleteBindingRefreshRequest$outboundSchema: z.ZodMiniType<
  CompleteBindingRefreshRequest$Outbound,
  CompleteBindingRefreshRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    completeBindingRefreshRequestBody:
      CompleteBindingRefreshRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      completeBindingRefreshRequestBody: "CompleteBindingRefreshRequestBody",
    });
  }),
);

export function completeBindingRefreshRequestToJSON(
  completeBindingRefreshRequest: CompleteBindingRefreshRequest,
): string {
  return JSON.stringify(
    CompleteBindingRefreshRequest$outboundSchema.parse(
      completeBindingRefreshRequest,
    ),
  );
}
